/**
 * bookKeepingStore
 * bookKeepingStore页面共用逻辑以及部分子组件与父组件通讯
 */
//  import orderBackCountUtil from '../../../static/js/backCountUtils/orderBackCountUtil'
//  import priceControlBackCountUtil from '../../../static/js/backCountUtils/priceControlBackCountUtil'
//  import sheetsBackCountUtil from '../../../static/js/backCountUtils/sheetsBackCountUtil'
//  import ratioBackCountUtil from '../../../static/js/backCountUtils/ratioBackCountUtil'
//  import safeGoodsBackCountUtil from '../../../static/js/backCountUtils/safeGoodsBackCountUtil'
// import calculateUtil from '../../../static/js/calculateUtil'
import { filters } from 'pangu-components-plus'
class BookKeepingStore {
  constructor(bookKeeping, initialState = {}, initialMutations, initialActions) {
    this.bookKeeping = bookKeeping

    //状态数据
    this.states = {
      treeClassifyData: null,
      treeClassifyDataFilter: null,
      searchParameters: {
        dateTime: [
          `${filters(new Date(), 'date', 'YYYY-MM-DD')} 00:00:00`,
          `${filters(new Date(), 'date', 'YYYY-MM-DD')} 23:59:59`,
        ],
        // beginDate: calculateUtil.formatDate(
        //   new Date(new Date(new Date().toLocaleDateString()).getTime())
        // ),
        // endDate: calculateUtil.formatDate(
        //   new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        // ),
      },
      //当前的请求参数
      param: {},
      formData: null,

      parentDataKey: 'parentFormData',

      //设置点击的状态
      showRight: false,
      //设置当前的tab
      currentTab: 0,
      //当前的tab 名称
      currentTabName: null,
      //当前tab 的props
      currentTabProps: null,
      //左侧的选中数据的model
      choseData: null,
      // 是否隐藏脱敏信息
      disabledView: false,
    }

    //修改states的方法
    this.mutations = {
      //设置选择的数据
      setChoseData(states, data) {
        this.states.choseData = data
      },
      //清除选择的数据
      clearChoseData() {
        this.states.choseData = null
      },
      //设置请求参数
      param(states, data) {
        this.states.param = data
      },
      // 更新是否隐藏脱敏信息
      setDisabledView(states, data) {
        this.states.disabledView = data
      },
      //设置分类树的数据
      setTreeClassifyData(states, data, isCheck) {
        this.states.treeClassifyData = data
        const filterData = this.states.treeClassifyData?.filter((item) => {
          return item.clinicalDepartment === isCheck
        })
        this.states.treeClassifyDataFilter = filterData
      },
      //过滤分类数数据
      filterTreeClassfyData(states, isCheck) {
        const filterData = this.states.treeClassifyData?.filter((item) => {
          return item.clinicalDepartment === isCheck
        })
        this.states.treeClassifyDataFilter = filterData
      },
      //清除分类树的数据
      clearTreeClassifyData() {
        this.states.treeClassifyData = null
      },
      //设置查询的参数
      setSearchParameters(states, data) {
        this.states.searchParameters = Object.assign(this.states.searchParameters, data)
      },

      //清空查询的参数
      clearSearchParameters(states, data) {
        this.states.searchParameters = data
      },

      //修改右边显示的状态
      setShowRight(states, data) {
        this.states.showRight = data
      },

      //修改右边显示的状态
      setCurrentTab(states, data) {
        this.states.currentTabName = data
        if (data == '库存添加') this.states.currentTab = 0
        if (data == '跟台添加') this.states.currentTab = 1
        if (data == '手术记账') this.states.currentTab = 2
      },
      //设置当前的tab的内容
      setCurrentTabProps(states, data) {
        this.states.currentTabProps = [...data]
      },

      //设置form 表单信息
      setFormData(states, data) {
        this.states.formData = data
        // this.commit('updateCurrentTabProps')
      },
      //更新表单数据
      updateFormData(states, data, vue, value) {
        this.bookKeeping.getOfEdit(this.states.param, value)
        // this.bookKeeping.setCurrentTabData(this.bookKeeping.currentProps[states.currentTab],'bookkeep')
      },

      //清空clearCurrentTabProps
      clearCurrentTabProps() {
        this.states.currentTabProps = null
      },

      //更新formDataItems
      updateFormDataItems(states, data) {
        this.states.formData.items = [...states.formData.items, ...data]
      },
      //更新当前tab 的数据
      updateCurrentTabProps() {
        //如果所有的数据一次性给的那这里我们要进行处理  表示  跟台==>'fllow'    备货==>'Stock'  手术记账==>'bookkeep'
        //跟台
        if (this.states.currentTabProps[this.states.currentTab].componentProps.mark == 'follow') {
          this.states.currentTabProps[this.states.currentTab].componentProps.topData =
            this.states.formData?.items.filter((item) => {
              return item.srcType == 'OPERATION_CHECK' && item.posted == false
            })
          this.states.currentTabProps[this.states.currentTab].componentProps.bottomData =
            this.states.formData?.items.filter((item) => {
              return item.srcType == 'OPERATION_CHECK' && item.posted == true
            })
        }
        //备货
        if (this.states.currentTabProps[this.states.currentTab].componentProps.mark == 'stock') {
          this.states.currentTabProps[this.states.currentTab].componentProps.topData =
            this.states.formData?.items.filter((item) => {
              return (
                (item.srcType == 'STORE' ||
                  item.srcType == 'OPERATION_TEMP' ||
                  item.srcType == 'STORE_RFID_OUTGOING') &&
                item.posted == false
              )
            })

          this.states.currentTabProps[this.states.currentTab].componentProps.bottomData =
            this.states.formData?.items.filter((item) => {
              return (
                (item.srcType == 'STORE' ||
                  item.srcType == 'OPERATION_TEMP' ||
                  item.srcType == 'STORE_RFID_OUTGOING') &&
                item.posted == true
              )
            })
        }
        //手术记账
        if (this.states.currentTabProps[this.states.currentTab].componentProps.mark == 'bookkeep') {
          this.states.currentTabProps[this.states.currentTab].componentProps.value =
            this.states.formData?.items.filter((item) => {
              return item.posted == true
            })
        }
        //触发 更新机制
        this.states.currentTabProps = [...this.states.currentTabProps]
      },
    }
    //操作方法
    this.actions = {}

    //初始赋值自定义state
    for (let prop in initialState) {
      if (
        Object.prototype.hasOwnProperty.call(initialState, prop) &&
        Object.prototype.hasOwnProperty.call(this.states, prop)
      ) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (Object.prototype.hasOwnProperty.call(initialMutations, prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }

    //初始赋值自定义actions
    for (let prop in initialActions) {
      if (Object.prototype.hasOwnProperty.call(initialActions, prop)) {
        this.actions[prop] = initialActions[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default BookKeepingStore
